import "./polyfills";

import { createApp } from "vue";
import global from "@/global"
import WordAddin from "./plugin";
import WordMock from "@/mocks/word/wordMock";
import OfficeMock from "@/mocks/word/officeMock";
import DebugCommands from "@/mocks/commands/debugCommands";
import contentControls from "@/services/word/contentControlsService";
import documentModel from "@/services/word/documentModelService";
import { isLegacyBrowser } from "@/util/legacy";
import { openLegacyBrowserPage } from "@/util/urlBuilder";
import "@/_css/theme.scss";

let router, store;

const setCurrentPlaceholder = async () => {
  const currentPlaceholder = await contentControls.getCurrentPlaceholder();
  store.commit("currentPlaceholder", { placeholder: currentPlaceholder });
}

const flagContentSelected = async () => {
  const selected = await contentControls.isContentSelected();
  store.commit("contentSelected", { selected });
}

const loadDocumentModel = async () => {
  const model = await documentModel.get();
  if (model) {
    store.commit("documentModel", { model });
  }
}

const isNonAppPage = () => {
  const nonAppPages = ["#/help", "#/diagnostics", "#/ie-support"];

  return nonAppPages.some(page => window.location.hash.toLowerCase().startsWith(page));
}

const startApp = async () => {
  const loadAppSettings = fetch("static/appsettings.json")
    .then(result => result.json())
    .then(appSettings => {
      global.setAppSettings(appSettings);
    });

  const loadRestrictedEnvironments = fetch("static/restrictedEnvironments.json")
    .then(result => result.json())
    .then(environments => {
      global.setRestrictedEnvironments(environments);
    })

  await Promise.all([loadAppSettings, loadRestrictedEnvironments]);
  
  const app = createApp(WordAddin.App);
  app.use(WordAddin);
  router = WordAddin.Router();
  store = WordAddin.Store();
  app.mount('#app');
}

if (isNonAppPage()) {
  startApp();
} else if (isLegacyBrowser()) {
  window.location.href = openLegacyBrowserPage();
  startApp();
} else {
  window.Office.onReady(async info => {
    if (!info.host) {
      console.log("Application being run in the browser.  All Word operations will be logged to the console.");
      window.Office = new OfficeMock();
      window.Word = new WordMock();
    }

    // Initialize app and store FIRST
    await startApp();

    // Now store is available for DebugCommands
    if (!info.host) {
      window.$debug = new DebugCommands(store);
    }

    if (window.Office.context.document) {
      const document = window.Office.context.document;

      store.commit("currentDocument", { document: document.url });

      await loadDocumentModel();
      await setCurrentPlaceholder();
      await flagContentSelected();

      document.addHandlerAsync(Office.EventType.DocumentSelectionChanged, async () => {
        await setCurrentPlaceholder();
        await flagContentSelected();
      });
    }
  });
}